import * as ACTION_TYPES from './types';

const initState = {
  modalList: [],
};

export default function reducer(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.MODAL_LIST_ADD:
      return {
        ...state,
        modalList: [...state.modalList, payload],
      };
    case ACTION_TYPES.MODAL_LIST_REMOVE:
      return {
        ...state,
        modalList: state.modalList.filter(e => e.id !== payload.id),
      };
    case ACTION_TYPES.MODAL_LIST_CLEAR:
      return {
        ...state,
        modalList: [],
      };
    default:
      return state;
  }
}
